/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum AkceSablonyE {
    Detail = 'DETAIL',
    Smazat = 'SMAZAT',
    Editace = 'EDITACE',
    Archivovat = 'ARCHIVOVAT',
    Zneplatneni = 'ZNEPLATNENI',
    NovaVerze = 'NOVA_VERZE',
    Publikovat = 'PUBLIKOVAT',
    VratitKDopracovani = 'VRATIT_K_DOPRACOVANI',
    Schvalit = 'SCHVALIT',
    Stanovisko = 'STANOVISKO',
    OdeslatNaSchvaleni = 'ODESLAT_NA_SCHVALENI',
    NahratDokumentaci = 'NAHRAT_DOKUMENTACI',
    Kopie = 'KOPIE',
    Pdf = 'PDF',
    VratitKPriprave = 'VRATIT_K_PRIPRAVE',
    Predschvalit = 'PREDSCHVALIT',
    OdeslatNaPredschvaleni = 'ODESLAT_NA_PREDSCHVALENI',
    Konzultace = 'KONZULTACE',
    PotvrzeniNahraniDokumentace = 'POTVRZENI_NAHRANI_DOKUMENTACE',
    AktualizaceNahraneDokumentace = 'AKTUALIZACE_NAHRANE_DOKUMENTACE'
}

